import KendoSliderMixin from './KendoSliderMixin'

export default {
    name: 'kendo-slider',
    mixins: [ KendoSliderMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/index.js